import { Box, Container, Typography } from "@mui/material";
import VerticalCarousel from "./components";

const NewWay = () => {
  return (
    <Box
      component="section"
      pt={{ xs: 2.5, md: 8, lg: 17.5 }}
      pb={{ xs: 7.5, md: 12.5, lg: 43.75 }}
      bgcolor="background.default"
    >
      <Container>
        <Box maxWidth={{ sm: 848 }} mx="auto">
          <Typography
            variant="h2"
            textAlign={{ xs: "start", sm: "center" }}
            mx={"auto"}
            mb={2}
          >
            The Better Way to Track and Manage Your Assets
          </Typography>
          <Typography
            variant="subtitle1"
            mb={{ xs: 1, md: 2 }}
            textAlign={{ xs: "start", sm: "center" }}
          >
            Trackmate technology represents the most advanced capabilities of GPS tracking available today. Choose a plan that best suits your needs and budget.
          </Typography>
        </Box>
      </Container>
      <VerticalCarousel />
    </Box>
  );
};

export default NewWay;
